import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.object.define-property.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*jshint esversion: 6 */
export var NumberUtils = /*#__PURE__*/function () {
  function NumberUtils() {
    _classCallCheck(this, NumberUtils);
  }

  _createClass(NumberUtils, null, [{
    key: "toCurrencyString",
    value: function toCurrencyString(amount) {
      amount = Number(amount);
      amount = isNaN(amount) === false && !!amount ? +amount : 0;
      return amount.toLocaleString('en', {
        style: 'currency',
        currency: 'USD'
      });
    }
  }]);

  return NumberUtils;
}();